import { render, staticRenderFns } from "./PRICECHANGE.vue?vue&type=template&id=7114bb6e"
import script from "./PRICECHANGE.vue?vue&type=script&lang=js"
export * from "./PRICECHANGE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports